<template>
  <span
    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
    :class="claseEstado"
  >
    <span v-if="mostrarPunto" class="w-1.5 h-1.5 rounded-full mr-1.5" :class="clasePunto"></span>
    {{ textoEstado }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  estado: {
    type: String,
    required: true
  },
  tipo: {
    type: String,
    default: 'general', // general, cuenta, movimiento, pago
    validator: (value) => ['general', 'cuenta', 'movimiento', 'pago'].includes(value)
  },
  mostrarPunto: {
    type: Boolean,
    default: true
  }
})

const configuracionEstados = {
  // Estados generales
  activo: {
    clase: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    clasePunto: 'bg-green-500',
    texto: 'Activo'
  },
  inactivo: {
    clase: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
    clasePunto: 'bg-gray-500',
    texto: 'Inactivo'
  },

  // Estados de cuentas por cobrar/pagar
  pendiente: {
    clase: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
    clasePunto: 'bg-yellow-500',
    texto: 'Pendiente'
  },
  parcial: {
    clase: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
    clasePunto: 'bg-blue-500',
    texto: 'Pago Parcial'
  },
  pagada: {
    clase: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    clasePunto: 'bg-green-500',
    texto: 'Pagada'
  },
  vencida: {
    clase: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    clasePunto: 'bg-red-500',
    texto: 'Vencida'
  },
  cancelada: {
    clase: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400',
    clasePunto: 'bg-gray-500',
    texto: 'Cancelada'
  },

  // Estados de movimientos
  ingreso: {
    clase: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    clasePunto: 'bg-green-500',
    texto: 'Ingreso'
  },
  gasto: {
    clase: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    clasePunto: 'bg-red-500',
    texto: 'Gasto'
  },
  transferencia: {
    clase: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400',
    clasePunto: 'bg-purple-500',
    texto: 'Transferencia'
  },

  // Estados de tipo de cuenta
  ahorro: {
    clase: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
    clasePunto: 'bg-blue-500',
    texto: 'Ahorro'
  },
  corriente: {
    clase: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400',
    clasePunto: 'bg-indigo-500',
    texto: 'Corriente'
  },
  inversion: {
    clase: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400',
    clasePunto: 'bg-violet-500',
    texto: 'Inversión'
  }
}

const claseEstado = computed(() => {
  const config = configuracionEstados[props.estado.toLowerCase()]
  return config?.clase || 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
})

const clasePunto = computed(() => {
  const config = configuracionEstados[props.estado.toLowerCase()]
  return config?.clasePunto || 'bg-gray-500'
})

const textoEstado = computed(() => {
  const config = configuracionEstados[props.estado.toLowerCase()]
  return config?.texto || props.estado
})
</script>
